export const SECTIONS = {
    OBJECT: 'object-section',
    SECONDARY: 'secondary-sat-info',
};
export const EL = {
    TYPE: 'sat-type',
    STATUS: 'sat-status',
    COUNTRY: 'sat-country',
    SITE_ROW: 'sat-site-row',
    LAUNCH_SITE: 'sat-launchSite',
    LAUNCH_PAD: 'sat-launchPad',
    VEHICLE: 'sat-vehicle',
    CONFIGURATION: 'sat-configuration',
    RCS: 'sat-rcs',
    STDMAG: 'sat-stdmag',
    // Secondary satellite elements
    DIST: 'sat-sec-dist',
    RAD: 'sat-sec-rad',
    INTRACK: 'sat-sec-intrack',
    CROSSTRACK: 'sat-sec-crosstrack',
};
